import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map, single } from 'rxjs/operators';
import { ReportTemplateFieldDefinition } from 'src/dto/report-template';
import { ReportTemplateFieldCategory } from 'src/dto/report-template/report-template-field-category.enum';

@Pipe({ name: 'templateToolboxItemFilter' })
export class TemplateToolboxItemFilterPipe implements PipeTransform {
  transform(
    value: Observable<[ReportTemplateFieldCategory, ReportTemplateFieldDefinition[]]>,
    args: ReportTemplateFieldCategory
  ): Observable<ReportTemplateFieldDefinition[]> {
    return value.pipe(
      single(categorizedFieldDefinitions => categorizedFieldDefinitions[0] === args),
      map(x => (x ? x[1] : []))
    );
  }
}
